import AccountPopupView from './AccountPopupViewContainer';
export default AccountPopupView;
